var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wxLoginPageLoadBox"},[_c('div',{staticClass:"wxLoginPageLoad"},[_c('el-image',{attrs:{"src":require('../../static/image/common/loading.gif'),"fit":"scale-down"}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.msg)+" "),_c('div',{staticClass:"borderBottom"})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }